import Choices from "choices.js";

export default function kobleAutocomplete(){
    let element = document.querySelector('select.autocomoplete');

    if(!element) return;

    let name = element.dataset.name;
    let elementValue =  document.querySelector('.field-value[name="' + name + '"]');

    let choices = new Choices(element, {
        removeItems: true,
        searchResultLimit: 6,
        renderChoiceLimit: 6,
        searchFloor: 1,
    });

    // Only show dropdown when typing
    element.addEventListener('search', function(event) {
        const value = event.detail.value;
        const container = choices.containerOuter.element;
        
        if (value.length > 0) {
            container.classList.add('is-typing');
        } else {
            container.classList.remove('is-typing');
        }
    });

    // Reset when dropdown is closed or item added
    element.addEventListener('hideDropdown', function() {
        const container = choices.containerOuter.element;
        container.classList.remove('is-typing');
    });

    element.addEventListener('addItem', function(value){
        let val = value.detail.value;
        let elementValueVal = elementValue.value ? elementValue.value : "";
        let elementValueValArray = elementValueVal.split(',').filter(n => n);
        elementValueValArray.push(val);
        elementValue.value = elementValueValArray.join(',');
    });
    
    element.addEventListener('removeItem', function(value){
        let val = value.detail.value;
        let elementValueVal = elementValue.value ? elementValue.value : "";
        let elementValueValArray = elementValueVal.split(',').filter(n => n);
        const index = elementValueValArray.indexOf(val);
        if (index > -1) { 
            elementValueValArray.splice(index, 1);
        }
        elementValue.value = elementValueValArray.join(',');
        
    });

    element.addEventListener('change', function(value){
        let option = element.querySelector('option');
        let parent = element.closest('.choices');

        if(option){
            parent.classList.add('filled');
        }else{
            parent.classList.remove('filled');
        }
    });
}
